import {get, patchJson, postJson} from 'app/utils/request';

import {UserJobSerializedType} from 'sweet-types';

export const postAsyncJobFetcher = (
  url: string,
  obj: any
): Promise<{job: UserJobSerializedType}> => postJson(url, obj);

export const userJobDetailsFetcher = (
  url: string
): Promise<UserJobSerializedType> => get(url);

export const markUserJobAsViewedFetcher = (
  url: string,
  payload: {viewed_at: string}
): Promise<UserJobSerializedType> => patchJson(url, payload);
